import { authApi } from './authApi';

export const createDesignation = async (payload: any) => {
  return await authApi.post('admin/designation/', payload);
};

export const fetchDesignation = async (params?: string): Promise<any> => {
  const url = params ? `admin/designation/${params}` : 'admin/designation/';
  return await authApi.get(url);
};

export const updateDesignation = async (payload: any) => {
  return await authApi.patch(
    `admin/designation/${payload?.id}/`,
    payload?.body
  );
};

export const bulkDesignationStatus = async (payload: any) => {
  return await authApi.patch(`admin/designation/status_update/`, payload);
};
